






























/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

import TasksAPI from '@/api/modules/tasks.api'

/* Data types */
import { IChecklist, IChecklistItem } from '@/api/types/response.types'

/* API */

export default Vue.extend({
  name: 'ChecklistItemsList',

  props: {
    checklists: {
      type: Array as () => IChecklist[],
      default: (): IChecklist[] => [],
    },
  },

  data() {
    return {
      showAllItems: false,
      showModal: false,
    }
  },

  computed: {
    itemsToDisplay(): IChecklist[] {
      return this.checklists
    },
    projectID(): number {
      return Number(this.$route.params.id)
    },
    taskID(): number {
      return Number(this.$route.params.childId)
    },
  },

  methods: {
    handleChecklistItemAddClick(checklist: IChecklist) {
      const response = TasksAPI.post_ChecklistItemCreate(
        this.projectID,
        this.taskID,
        checklist.id,
        'New Item',
      ).then(newItem => {
        if (!checklist.checklistItems) {
          checklist.checklistItems = []
        }
        checklist.checklistItems.push(newItem)
        this.$nextTick(() => {
          const itemInput = (this.$refs[
            `itemInputs${checklist.id}_${newItem.id}`
          ] as HTMLInputElement[])[0]
          itemInput.focus()
        })
      })
    },
    handleChecklistItemEnterClick(checklist: IChecklist, itemIndex: number) {
      if (itemIndex === checklist.checklistItems.length - 1) {
        this.handleChecklistItemAddClick(checklist)
      }
    },
    handleCheckboxItemDoneClick(checklist: IChecklist, item: IChecklistItem) {
      const response = TasksAPI.put_ChecklistItemUpdate(
        this.projectID,
        this.taskID,
        checklist.id,
        item.id,
        {
          name: null,
          isDone: item.isDone,
        },
      )
    },
    handleChecklistItemNameChange(checklist: IChecklist, item: IChecklistItem) {
      const response = TasksAPI.put_ChecklistItemUpdate(
        this.projectID,
        this.taskID,
        checklist.id,
        item.id,
        {
          name: item.name,
          isDone: null,
        },
      )
    },
    handleChecklistItemDeleteClick(
      checklist: IChecklist,
      item: IChecklistItem,
    ) {
      this.$confirm(`${item.name}`, {
        center: true,
        confirmButtonText: 'Yes, Delete',
        confirmButtonClass: 'el-button--strawberry',
        cancelButtonText: 'Cancel',
        cancelButtonClass: 'el-button--text',
        type: 'warning',
        title: 'Are you sure you want to delete this item?',
      }).then(() => {
        const index = checklist.checklistItems.indexOf(item)
        if (index > -1) {
          checklist.checklistItems.splice(index, 1)
          const response = TasksAPI.delete_ChecklistItemDelete(
            this.projectID,
            this.taskID,
            checklist.id,
            item.id,
          )
        }
      })
    },
  },
})
